import { render, staticRenderFns } from "./Gmb.vue?vue&type=template&id=fc2362e2&scoped=true&"
import script from "./Gmb.vue?vue&type=script&lang=js&"
export * from "./Gmb.vue?vue&type=script&lang=js&"
import style0 from "./Gmb.vue?vue&type=style&index=0&id=fc2362e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc2362e2",
  null
  
)

export default component.exports